import FormDesign from './FormDesign.vue';
import FromRender from '../FormRender/FromRender.vue';

export default {
  install: app => {
    app.component(FormDesign.name, FormDesign);
    app.component(FromRender.name, FromRender);
  },
};
